import { useTemplateSettings } from "@/features/material-compliance/api/templateSettingsApi"
import type { InquiryTemplateSettings } from "@/features/material-compliance/components/supplier-declarations/inquiry/settings/templateSettingsMock"
import type { ReactNode } from "react"
import { SettingsSection } from "./SettingsPage"
import { SettingsLoadError, SettingsSkeleton } from "./SettingsStates"

/**
 * Renders a form once the org's inquiry settings have loaded, so the form
 * starts from the saved values and a background refetch never resets an edit
 * in progress. Until then: placeholder rows, or the error with a retry.
 */
export function TemplateSettingsLoader({
  children,
}: {
  children: (settings: InquiryTemplateSettings) => ReactNode
}) {
  const { data, isLoading, isError, isFetching, refetch } =
    useTemplateSettings()
  if (data) return children(data)
  return (
    <SettingsSection>
      {isLoading && !isError ? (
        <SettingsSkeleton />
      ) : (
        <SettingsLoadError
          pending={isFetching}
          onRetry={() => void refetch()}
        />
      )}
    </SettingsSection>
  )
}
